import { render, staticRenderFns } from "./permissionDialog.vue?vue&type=template&id=47329935&scoped=true"
import script from "./permissionDialog.vue?vue&type=script&lang=ts"
export * from "./permissionDialog.vue?vue&type=script&lang=ts"
import style0 from "./permissionDialog.vue?vue&type=style&index=0&id=47329935&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47329935",
  null
  
)

export default component.exports